import React, { memo } from 'react'
import withStyles from '@material-ui/core/styles/withStyles'
import { primaryGradient } from 'root/src/client/web/commonStyles'
import SecondaryButton from 'root/src/client/web/base/CustomButton/SecondaryButton'

const style = {
	btnContainer: {
		position: 'fixed',
		right: 100,
		top: 150,
		zIndex: 1000,
	},
	btn: {
		background: primaryGradient,
		padding: 30,
		fontSize: 14,
		border: 'none',
	},
	spinner: {
		'& svg': {
			margin: 'unset',
		},
	},
}

const Button = memo(({ classes, label, onClick, image }) => (
	<div
		className={classes.btnContainer}
	>
		<SecondaryButton
			image={image}
			className={classes.btn}
			title={label}
			onClick={onClick}
		/>
	</div>
))

export default withStyles(style, { name: 'MuiButtonFixed' })(Button)
